import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-chat-view-delete-confirmation-dialog',
  templateUrl: './chat-view-delete-confirmation-dialog.component.html',
  styleUrl: './chat-view-delete-confirmation-dialog.component.scss'
})
export class ChatViewDeleteConfirmationDialogComponent extends BaseComponent implements OnInit {
  @Input() chatName!: string;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  ngOnInit(): void {
  }

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
